<template>
  <div class="d-flex px-1">
    <div class="w-50-per pr-1 mt-n7">
      <TabelaDetalhesCategoria
        :count_atualizar_detalhes_categoria="count_atualizar_detalhes_categoria"
        class="ml-1" :categoria="categoria_selecionada"
      />
    </div>

    <div class="w-50-per border-left-gray" style="height: 275px;">
      <GraficoMovimentacoesEstoqueCategoria
        :count_atualizar_detalhes_categoria="count_atualizar_detalhes_categoria"
        :categoria="categoria_selecionada"
      />
    </div>
  </div>
</template>

<script>
import {categoria_selecionada} from "../helpers/CategoriaSelecionado";
import {parametros_rota} from "../helpers/ParametrosRota.js";
import TabelaDetalhesCategoria from "./TabelaDetalhesCategoria.vue";
import GraficoMovimentacoesEstoqueCategoria from "./graficoMovimentacoes/Index.vue";

export default {
  name: "Index.vue",
  mixins: [categoria_selecionada, parametros_rota],
  components: {
    TabelaDetalhesCategoria,
    GraficoMovimentacoesEstoqueCategoria
  },
  data: () => ({
    count_atualizar_detalhes_categoria: 0
  }),
  mounted() {
    // essa funcao serve para atualizar o detalhes da categorias de qualquer lugar
    this.$store.dispatch("comprasPorDepartamentos/callbackAtualizarDetalhesCategoria", this.atualizarDetalhesCategoria);
  },
  methods: {
    atualizarDetalhesCategoria() {
      if (this.categoria_selecionada) {
        this.count_atualizar_detalhes_categoria += 1;
      }
    }
  }
}
</script>

<style scoped>
.w-50-per {
  width: 50%;
}
.border-left-gray {
  border-left: 1px solid #ece7e7;
}
</style>
